import { get, isEmpty } from "lodash";
import { getTagTypeName } from "src/util/tags";

export const isTagType = (tagTypesConfig, nodeId) => {
  const tagTypeConfig = get(tagTypesConfig, nodeId, {});
  return !isEmpty(tagTypeConfig);
};

export const createTagTypeNode = (tagTypeId, tagTypesConfig = {}) => ({
  id: tagTypeId,
  type: tagTypeId,
  tagTypeName: getTagTypeName(tagTypeId, tagTypesConfig),
});
